// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0c622b1d","455":"29876308","977":"e32dea4b"}[chunkId] + ".chunk.js";
};